module.exports = {
  label: {
    headerTitle: 'Assign Questionnaires to the site',
    AddheaderTitle: 'Add Assign Questionnaires to the site',
    EditheaderTitle: 'Edit Assign Questionnaires to the site',
    site: 'Site',
    questionnaire: 'Questionnaire',
    isActive: 'Is Active',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      openInNew: 'Submit Form',
      copy: 'Copy Link',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      submit: 'Submit Form',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete'
    }
  }
}
